import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { concat, Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, filter, finalize, map, startWith, switchMap, takeUntil, tap } from 'rxjs/operators';
import { ToastService } from 'src/app/core';
import { ActiveDirectoryService } from 'src/app/core/active-directory.service';
import { AdUser, HttpStatusCode, OfficeEntity, OfficeLocation, RoleType, ServiceLine, UserApi, UserInfo, UserRole } from 'src/app/core/api.gen';
import { CommonService } from 'src/app/core/common.service';
import { LoaderService } from 'src/app/core/loader.service';
import { nullSafe } from 'src/app/utils';
import { isNullOrUndefined } from '../../../app/core/utils';

@Component({
  selector: 'eos-user-editor',
  templateUrl: './user-editor.component.html',
  styleUrls: ['./user-editor.component.css']
})
export class UserEditorComponent implements OnInit, OnDestroy {

  userInfo: UserInfo;
  title: string;
  OnAction: Function;

  editMode: boolean;
  form: UntypedFormGroup;
  roles$: Observable<UserRole[]>;
  ole$: Observable<OfficeEntity[]>;
  sl$: Observable<ServiceLine[]>;
  locations$: Observable<OfficeLocation[]>;
  empCategory$: Observable<any[]>;
  contractTypes$: Observable<any[]>;
  allContractTypes: any[] = [];
  userRoles$: string[] = [];
  activeRole: string = null;

  onDestroy$ = new Subject<void>();
  searchInput$ = new Subject<string>();
  options$;
  delegateOpts$;
  showLoader = false;

  roleddSettings = {
    singleSelection: false,
    idField: 'role',
    textField: 'role',
    // selectAllText: 'Select All',
    // unSelectAllText: 'UnSelect All',
    enableCheckAll: true,
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  // locddSettings = {
  //   singleSelection: true,
  //   idField: 'id',
  //   textField: 'role',
  //   // selectAllText: 'Select All',
  //   // unSelectAllText: 'UnSelect All',
  //   enableCheckAll: true,
  //   itemsShowLimit: 3,
  //   allowSearchFilter: true
  // };
  leddSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'displayText',
    // selectAllText: 'Select All',
    // unSelectAllText: 'UnSelect All',
    enableCheckAll: true,
    itemsShowLimit: 1,
    allowSearchFilter: true
  };


  constructor(
    private loader: LoaderService,
    private common: CommonService,
    private userApi: UserApi,
    private toast: ToastService,
    private ad: ActiveDirectoryService,
    public modal: NgbActiveModal
  ) { }

  get isDubaiSelected(): string {
    // array includes was not working hence he filter
    if (this.form.value.locations?.filter(item => item.id === 661).length > 0 &&
      this.form.value.locations?.filter(item => item.id === 669).length === 0) {
      return 'Please select Sharjah if applicable';
    } else {
      return '';
    }
  }

  adjustValues() {
  }

  setUserRolesList(event) {
    this.userRoles$ = nullSafe(() => event.filter(r => r.role != 'Admin').map(r => r.role), []);
    const actRole = this.form.get('activeRole').value;
    if (actRole && !this.userRoles$.includes(actRole)) {
      this.activeRole = null;
      this.form.get('activeRole').reset();
    }
  }

   
  ngOnInit() {
    this.editMode = !isNullOrUndefined(this.userInfo?.userId);   
    this.roles$ = this.common.prepareRolesObservable();
    this.ole$ = this.common.prepareOfficeEntityObservable();
    this.sl$ = this.common.prepareServiceLineObservable();
    this.locations$ = this.common.prepareMenaOfcLocations(); // taken from dbo.lookupfields office locations.
    this.empCategory$ = this.common.prepareEmployeeCategoryOptions();
    this.contractTypes$ = this.common.prepareContractTypeOptions();
    this.userRoles$ = this.userInfo ? this.userInfo.roles : [];
    if (this.editMode) {
      this.roles$.subscribe(val => {
        this.form.get('roles').setValue(val.filter(r => this.userInfo.roles.some(x => x === r.role)));
      });

      this.ole$.subscribe(val => {
        this.form.get('les').setValue(val.filter(l => this.userInfo.officeEntities.some(x => x === l.id)));
      });

      this.locations$.subscribe(val => {
        this.form.get('locations').setValue(val.filter(l => this.userInfo.officeLocations.some(x => x === l.id)));
        this.form.get('exitLocations').setValue(val.filter(l => this.userInfo.exitLocations.some(x => x === l.id)));
      });
      this.sl$.subscribe(val => {
        this.form.get('exitServiceLines').setValue(val.filter(l => this.userInfo.exitServiceLines.some(x => x === l.id)));
      });
    }    
       // for PJ
      this.empCategory$.subscribe(val => {
        this.form.get('empCategories').setValue(val.filter(l => this.userInfo.employeeCategories.some(x => x === l.id)));
        // Call getContractTypeFilters after employee categories are set
        if (this.allContractTypes.length > 0) {
          this.getContractTypeFilters();
        }
      });
      this.contractTypes$.subscribe(val => {
        this.allContractTypes = val;
        this.form.get('contractTypes').setValue(val.filter(l => this.userInfo.contractTypes?.some(x => x === l.id)));
        // Call getContractTypeFilters after allContractTypes is populated (in case empCategory$ hasn't completed yet)
        const empCategoriesValue = this.form.get('empCategories').value;
        if (empCategoriesValue && empCategoriesValue.length > 0) {
          this.getContractTypeFilters();
        }
      });
     
      this.options$ = concat(
      of([]),
      this.searchInput$.pipe(
        takeUntil(this.onDestroy$),
        startWith(''),
        filter(v => v !== null && v.length > 2),
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => this.showLoader = true),
        switchMap(term => this.ad.getAdUsers(term).pipe(
          catchError(() => of([])),
          tap(() => this.showLoader = false)
        ))
      )
    );
    if (this.editMode) {
      this.form = new UntypedFormGroup({
        name: new UntypedFormControl({ value: this.userInfo.displayName, disabled: this.editMode }),
        email: new UntypedFormControl({ value: this.userInfo.email, disabled: true }),
        roles: new UntypedFormControl([]),
        locations: new UntypedFormControl([]),
        les: new UntypedFormControl([]),
        aduser: new UntypedFormControl(''),
        activeRole: new UntypedFormControl(''),
        delegate: new UntypedFormControl(''),
        active:new UntypedFormControl(''),
        exitLocations:new UntypedFormControl([]),
        exitServiceLines:new UntypedFormControl([]),
        empCategories: new UntypedFormControl([]),
        contractTypes: new UntypedFormControl([])
      });
    } else {
      this.form = new UntypedFormGroup({
        name: new UntypedFormControl({ value: '', disabled: this.editMode }),
        email: new UntypedFormControl({ value: '', disabled: true }),
        roles: new UntypedFormControl([]),
        locations: new UntypedFormControl([]),
        les: new UntypedFormControl([]),
        aduser: new UntypedFormControl(''),
        activeRole: new UntypedFormControl(null),
        delegate: new UntypedFormControl(null),
        active:new UntypedFormControl(null),
        exitLocations:new UntypedFormControl([]),
        exitServiceLines:new UntypedFormControl([]),
        empCategories: new UntypedFormControl([]),
        contractTypes: new UntypedFormControl([]),
      });
    }

    this.form.get('activeRole').valueChanges.subscribe(value => {
      this.loadDelegateList(null)
    });
    this.form.get('roles').valueChanges.subscribe(value => {
      this.setUserRolesList(value);
    });
    
    // Set up empCategories valueChanges subscription once
    this.form.get('empCategories').valueChanges.subscribe(selected => {
      this.filterContractTypesByEmployeeCategory(selected);
    });
    
    if (this.editMode) {
      this.form.get('activeRole').setValue(this.userInfo.activeRole);
      this.form.get('active').setValue(this.userInfo.isActive);
      this.form.get('delegate').setValue(this.userInfo.delegateEmpId == 0 ? null : this.userInfo.delegateEmpId);   
    }
  }

  get notOnlyEmpAndAdmin(){
    let roles = nullSafe(() => this.form.get('roles').value.map(r => r.role), [])

    if(roles.length == 1 && (roles.includes('Employee') || roles.includes('Admin')) && !this.noActiveRole) {
      return false;
    }
    if(roles.length == 2 && ['Admin', 'Employee'].every(s => roles.includes(s)) && !this.noActiveRole){
      return false;
    }

    return true;
  }

  get noActiveRole(){
    let activeRole = this.form.get('activeRole').value;

    if(activeRole){
      return false;
    }

    return true;
  }

  onCancel() {
    this.modal.dismiss();
  }

  roleType(activeRole): RoleType {
    const role = nullSafe(()=> activeRole.trim().split(' ').join('_'),'') ;
    return RoleType[role];
  }


  loadDelegateList(event) {
    const activeRole = this.form.get('activeRole').value as string;
    this.form.get('delegate').setValue(null);
    if (this.form.get('activeRole').value) {
      this.delegateOpts$ = this.userApi.getEmployeesByRole(this.roleType(activeRole))
        .pipe(map(data => data.filter(x => x.id != this.userInfo.employeeId && !x.disabled)));
    } else {
      this.delegateOpts$ = null;
    }
  }

  get updatedUserInfo(): UserInfo {

    this.userInfo.displayName = this.form.get('name').value;
    this.userInfo.email = this.form.get('email').value;
    this.userInfo.roles = nullSafe(() => this.form.get('roles').value.map(r => r.role), []);
    this.userInfo.officeEntities = nullSafe(() => this.form.get('les').value.map(r => r.id), []);
    this.userInfo.officeLocations = nullSafe(() => this.form.get('locations').value.map(r => r.id), []);
    this.userInfo.exitLocations = nullSafe(() => this.form.get('exitLocations').value.map(r => r.id), []);
    this.userInfo.exitServiceLines = nullSafe(() => this.form.get('exitServiceLines').value.map(r => r.id), []);
    this.userInfo.activeRole = nullSafe(() => this.form.get('activeRole').value);
    this.userInfo.delegateEmpId = this.form.get('delegate').value ? this.form.get('delegate').value : 0;
    this.userInfo.isActive=this.form.get('active').value?this.form.get('active').valid:false;
    this.userInfo.employeeCategories = nullSafe(() => this.form.get('empCategories').value.map(r => r.id), []);
    this.userInfo.contractTypes = nullSafe(() => this.form.get('contractTypes').value.map(r => r.id), []);
    return this.userInfo;
  }

getContractTypeFilters() {
 //to initialize the contract types based on existing emp categories
    const empCategoriesControl = this.form.get('empCategories');
    if (!empCategoriesControl) {
      return;
    }
    
    const initialEmpCategories = empCategoriesControl.value;

    if (initialEmpCategories && initialEmpCategories.length > 0) {
      this.filterContractTypesByEmployeeCategory(initialEmpCategories);
    } 
    else {
      this.contractTypes$ = of([]); // <-- Reset array
      this.form.get('contractTypes').setValue([]);
    }
  }
  
  filterContractTypesByEmployeeCategory(selected: any[]) {
    const contractTypesControl = this.form.get('contractTypes');
    if (selected && selected.length > 0) {
      // filter contract types where parentFieldId matches any selected empCategory id
      const selectedIds = selected.map(x => x.id);
      const filtered = this.allContractTypes.filter(ct => selectedIds.includes(ct.parentFieldId));
      // reset the value if it doesn't match the options
      contractTypesControl.setValue(
        (contractTypesControl.value || []).filter(v => filtered.some(f => f.id === v.id))
      );
      // assigning the filtered contract types to the observable
      this.contractTypes$ = of(filtered);
    } else {
      contractTypesControl.setValue([]);
      this.contractTypes$ = of([]);
    }
  }
  onSave() {
    if (!this.updatedUserInfo.activeRole || this.updatedUserInfo.activeRole.length === 0) {
      this.toast.error("Please select an active role");
      this.form.get('activeRole').markAsTouched();
      return;
    }
    this.loader.show();
    this.userApi.addUserWithRoles(this.updatedUserInfo)
      .pipe(finalize(() => this.loader.clear()))
      .subscribe(result => {
        this.form.reset();
        if (result.statusCode == HttpStatusCode.Created) {
          this.toast.success("User added successfully");
          if (this.OnAction) {
            this.OnAction();
          }
          this.modal.dismiss();
        }
      }, err => {
        this.toast.error("Error occured while adding user. please check logs for more details!");
      });
  }

  onUpdate() {
    if (!this.updatedUserInfo.activeRole || this.updatedUserInfo.activeRole.length === 0) {
      this.toast.error("Please select an active role");
      this.form.get('activeRole').markAsTouched();
      return;
    }
    // Validation for Employee category,contract type
    if (!this.ValidateContractTypesSelection()) {
      return;
    }
    
    this.loader.show();
    this.userApi.updateUserRoles(this.updatedUserInfo)
      .pipe(finalize(() => this.loader.clear()))
      .subscribe(result => {
        this.form.reset();
        if (result.statusCode == HttpStatusCode.Created) {
          this.toast.success("User rights updated successfully");
          this.form.markAsPristine();
          if (this.OnAction) {
            this.OnAction();
          }
          this.modal.dismiss();
        }
      }, err => {
        this.toast.error("Error occured while updating user. please check logs for more details!");
      });
  }

  onChange($event) {
    if (isNullOrUndefined($event) || $event.length == 0) {
      this.form.reset();
    }
    else {
      const adUser = $event as AdUser;
      if (adUser != null) {
        this.form.patchValue({ name: adUser.displayName, email: adUser.userPrincipalName });
        if (isNullOrUndefined(this.userInfo)) {
          this.userInfo = new UserInfo();
        }
        this.userInfo.displayName = adUser.displayName;
        this.userInfo.email = adUser.userPrincipalName;
        this.userInfo.firstName = adUser.givenName;
      }
    }
  }

  ngOnDestroy() {
    this.onDestroy$.complete();
  }
  ValidateContractTypesSelection(): boolean {
    const empCategories = this.form.get('empCategories').value || [];
    const contractTypes = this.form.get('contractTypes').value || [];
    
    // Check each selected employee category to see if it requires contract types
    for (const category of empCategories) {
      // Find all contract types that belong to this employee category
      const availableContractTypes = this.allContractTypes.filter(ct => ct.parentFieldId === category.id);
      
      // If this employee category has available contract types
      if (availableContractTypes.length > 0) {
        // Check if at least one contract type is selected for this category
        const hasSelectedContractType = contractTypes.some(selectedCt => 
          availableContractTypes.some(availableCt => availableCt.id === selectedCt.id)
        );
        
        if (!hasSelectedContractType) {
          this.toast.error(`At least one contract type must be selected for ${category.displayText}`);
          this.form.get('contractTypes').markAsTouched();
          return false;
        }
      }
    }
    return true;
  }
}
